export class VnSkyOscServiceEntity {
  name?: string;
  packageName?: string;
  startDate?: string;
  endDate?: string;
  used?: string;
  total?: string;
  unit?: string;
  dataUsed?: string;
  remaining?: string;

  constructor(data?: Partial<VnSkyOscServiceEntity>) {
    this.name = data?.name;
    this.packageName = data?.packageName;
    this.startDate = data?.startDate;
    this.endDate = data?.endDate;
    this.used = data?.used;
    this.total = data?.total;
    this.unit = data?.unit;
    this.dataUsed = data?.dataUsed;
    this.remaining = data?.remaining;
  }
}

export class VnSkyOscPackageEntity {
  packageName?: string;
  startDate?: string;
  endDate?: string;
  services?: Array<VnSkyOscServiceEntity>;

  constructor(data?: Partial<VnSkyOscPackageEntity>) {
    this.packageName = data?.packageName;
    this.startDate = data?.startDate;
    this.endDate = data?.endDate;
    this.services =
      data?.services?.map(
        (item) =>
          new VnSkyOscServiceEntity({
            ...item,
            startDate: data?.startDate,
            endDate: data?.endDate,
            packageName: data?.packageName,
          }),
      ) || [];
  }
}

export class VnSkyOscLookupResponseEntity {
  serial?: string;
  status?: number;
  subscriberStatus?: string;
  isdnType?: string;
  simType?: string;
  device?: string;
  imei?: string;
  phoneNumber?: string;
  packages?: Array<VnSkyOscPackageEntity>;

  constructor(data?: Partial<VnSkyOscLookupResponseEntity>) {
    this.serial = data?.serial;
    this.status = data?.status;
    this.subscriberStatus = data?.subscriberStatus;
    this.isdnType = data?.isdnType;
    this.simType = data?.simType;
    this.device = data?.device;
    this.imei = data?.imei;
    this.phoneNumber = data?.phoneNumber;

    this.packages =
      data?.packages?.map((item) => new VnSkyOscPackageEntity(item)) || [];
  }
}
